import { FormModule } from '@farris/devkit';
import { DgControlType } from '../../components/dg-control-type';

export class FormMetaDataContent {
    Id: string;
    Code: string;
    Name: string;
    Contents: {
        module: FormMetaDataModule,
        options?: FormOptions
    };
}

export class FormMetaDataContentForDB {
    Id: string;
    Code: string;
    Name: string;
    Contents: string;

    constructor(content: FormMetaDataContent) {
        this.Id = content.Id;
        this.Code = content.Code;
        this.Name = content.Name;
        this.Contents = JSON.stringify(content.Contents);
    }
}

export class FormMetadaDataDom {
    module: FormModule;
}

export class FormMetaDataModule {
    id: string;
    code: string;
    name: string;
    caption: string;
    type: string;
    creator: string;
    creationDate: Date;
    updateVersion: string;
    showTitle: boolean;
    boostrap: string;
    schemas: Array<FormSchema>;
    states: Array<any>;
    contents: Array<any>;
    stateMachines: Array<any>;
    viewmodels: Array<any>;
    components: Array<any>;
    webcmds: Array<any>;
    serviceRefs: Array<any>;
    ctrlLangs: any;

    // 是否移动审批表单
    isMobileApprove: boolean;

    // 是否组合表单
    isComposedFrm: boolean;

    // 表单所在的工程名
    projectName: string;

    // 外部模块声明
    extraImports: Array<{ name: string, path: string }>;

    // 外部组件
    externalComponents: Array<any>;
    // 当前组件声明：事件、变量、命令
    declarations: FormDeclaration;
    // 订阅
    subscriptions: Array<any>;
}

export class FormOptions {
    enableTextArea: boolean;
    enableDragAndDropToModifyLayout: boolean;
}

/**
 * Component节点
 */
export class FormComponent {
    id: string;
    type = 'Component';
    viewModel: string;
    componentType: FormComponentType | any;
    contents: any[];
    onInit: null;
    afterViewInit: null;
}

/**
 * 组件类型
 */
export enum FormComponentType {
    /**
     * 表单
     */
    Frame = 'Frame',

    /**
     * 列表/树表类
     */
    dataGrid = 'dataGrid',


    /**
     * 列表视图
     */
    listView = 'listView',

    /**
     * 卡片类（待优化，目前类型中带有控件列布局信息）
     */
    form = 'form',

    /**
     * 移动审批：人员信息组件
     */
    detailHeaderForMobileApprove = 'detailHeaderForMobileApprove',

    /**
     * 移动审批：面板
     */
    panelForMobileApprove = 'panelForMobileApprove',

    /**
     * 移动审批：流程图组件
     */
    flowProcessForMobileApprove = 'flowProcessForMobileApprove'
}


/**
 * DOM 控件binding实体
 */
export class FormBinding {
    public type: FormBindingType;
    public path: string;
    public field: string;
    public fullPath: string;
    // public bindingData?: any;
}

/**
 * binding 类型
 */
export enum FormBindingType {
    Form = 'Form',
    Variable = 'Variable'
}

/**
 * dom Json ViewModel 节点实体
 */
export class FormViewModel {
    public id: string;
    public code: string;
    public name: string;
    public fields: FormViewModelField[];
    public commands: any[];
    public states: FormVariable[];
    public serviceRefs: any[];
    public bindTo: string;
    public parent?: string;
    public enableUnifiedSession?: boolean;
    public pagination?: FormViewModelPagination;
}

/**
 * dom Json ViewModel 节点中fields实体
 */
export class FormViewModelField {
    public type: string;
    public id: string;

    // 字段bindingField
    public fieldName: string;

    // 分组
    public groupId: string;
    public groupName: string;

    // 字段变更增量
    public fieldSchema?: any;

    // 字段变化前后事件
    public valueChanging?: string;
    public valueChanged?: string;

    // 更新时机
    public updateOn?: string;
}

/**
 * dom Json ViewModel 节点中states实体
 */
export class FormVariable {
    public id = '';
    public code: string;
    public name: string;
    public value?: any;
    public type: string;
    public category = 'locale';
    public fields?: any[];
    public defaultValue?: any;
}

/**
 * 变量类型
 */
export enum FormVariableCategory {
    locale = 'locale',
    remote = 'remote'
}

/**
 * 支持的变量类型
 */
export const FormVariableTypes = [
    { text: '字符串', value: 'String' },
    { text: '数字', value: 'Number' },
    { text: '布尔', value: 'Boolean' },
    { text: '日期', value: 'Date' },
    { text: '日期时间', value: 'DateTime' },
    { text: '文本', value: 'Text' },
    { text: '对象', value: 'Object' },
    { text: '数组', value: 'Array' }
];

/**
 * DOM GridField 中的数据类型
 */
export enum GridFieldDataType {
    string = 'string',
    boolean = 'boolean',
    date = 'date',
    number = 'number',
    enum = 'enum',
    datetime = 'datetime'
}

/**
 * 枚举类型
 */
export class EnumData {
    public value: string;
    public name: string;
}

/**
 * Item类型数据
 */
export class ItemData {
    public value: string;
    public name: string;
}

/**
 * vm 分页配置
 */
export class FormViewModelPagination {
    public enable: boolean;
    public pageList?: string;
    public pageSize?: number;
}

/**
 * 组合表单-声明实体
 */
export class FormDeclaration {
    public events?: DeclarationEvent[];
    public commands?: DeclarationCommand[];
    public states?: DeclartionState[];
}

/**
 * 组合表单-事件声明实体
 */
export class DeclarationEvent {

    hId?: string;
    /** 事件类型：控件的事件/实体的事件 */
    public type: 'controlEvent' | 'fieldEvent';
    /** 编号 */
    public code: string;
    /** 名称 */
    public name: string;
    /** 事件 */
    public event: string;
    /** 路径 */
    public path: string;

    public params: DeclarationParam[];
}

/**
 * 组合表单-参数实体
 */
export class DeclarationParam {
    public hId?: string;
    /** 编号 */
    public code: string;
    /** 名称 */
    public name: string;
    /** 参数值 */
    public value: string;
}

/**
 * 组合表单-命令声明实体
 */
export class DeclarationCommand {
    /** ID */
    public hId?: string;
    /** 命令编号 */
    public code: string;
    /** 命令名称 */
    public name: string;
    /** 命令 */
    public command: string;
    /** 路径 */
    public path: string;
    /** 命令所在的组件ID */
    public componentId: string;
}


/**
 * 组合表单-变量声明实体
 */
export class DeclartionState {
    public hId?: string;
    /** 编号 */
    public code: string;
    /** 名称 */
    public name: string;
    /** 变量 */
    public state: string;
    /** 变量路径 */
    public path: string;
}

/**
 * 组合表单-订阅实体
 */
export class Subscription {
    /** 唯一标识 */
    public hId?: string;
    /** 源表单 */
    public sourceComponent: string;
    /** 原表单的事件编号 */
    public subscribeOn: string;
    /** 目标表单 */
    public targetComponent: string;
    /** 目标表单的命令编号 */
    public invoke: string;
    /** 目标表单的命令所在的组件ID */
    public invokeComponentId: string;
    /** 参数 */
    public paramMappings: SubscriptionParamMapping[];
}

/**
 * 组合表单-订阅参数实体
 */
export class SubscriptionParamMapping {
    /** 源参数编号 */
    public sourceCode: string;
    /** 目标参数编号 */
    public targetCode: string;
    /** 目标参数类型 */
    public targetType: string;
    /** 目标参数路径 */
    public targetPath: string;
}

/**
 * schema
 */
export class FormSchema {
    public dataSource: string;
    public sourceUri: string;
    public id: string;
    public code: string;
    public name: string;
    public entities: FormSchemaEntity[];
    public variables: FormSchemaEntityField[];
    public eapiId: string;
    public extendProperties: { enableStdTimeFormat: boolean };
}

/**
 * 实体
 */
export class FormSchemaEntity {
    public id: string;
    public code: string;
    public name: string;
    public label: string;
    public type: FormSchemaEntityType;
}

/**
 * 实体类型对象
 */
export class FormSchemaEntityType {
    public name: string;
    public primary: string;
    public fields: FormSchemaEntityField[];
    public entities?: FormSchemaEntity[];
    public displayName?: string;
}

/**
 * 字段
 */
export class FormSchemaEntityField {
    public $type: FormSchemaEntityField$Type;
    public id: string;
    public originalId: string;
    public code: string;
    public label: string;
    public bindingField: string;
    public name: string;
    public defaultValue: any;
    public require: boolean;
    public readonly: boolean;
    public type: FormSchemaEntityFieldType;
    public editor?: FormSchemaEntityFieldEditor;
    public path?: string;
    public bindingPath?: string;
    public multiLanguage?: boolean;
    // 表达式
    public expression?: any;
}

/**
 * 字段类型对象
 */
export class FormSchemaEntityFieldType {
    public $type: FormSchemaEntityFieldType$Type;
    public name: FormSchemaEntityFieldTypeName | any;
    public length?: number;
    public precision?: number;
    public valueType?: FormSchemaEntityFieldType;
    public enumValues?: EnumData[];
    public fields?: FormSchemaEntityField[];
    public displayName?: string;
    public primary?: string;
    public entities?: FormSchemaEntity[];
    // 用于区分日期/日期事件和整型/浮点型数据
    public elementType?: any;
    // 扩展属性:  运行时定制用
    public extendProperty?: any;
}

/**
 * 字段编辑器对象
 */
export class FormSchemaEntityFieldEditor {
    public $type: DgControlType;
    [propName: string]: any;
}

/**
 * 字段类型枚举
 */
export enum FormSchemaEntityField$Type {
    /**
     * 简单类型字段
     */
    SimpleField = 'SimpleField',
    /**
     * 关联/UDT类型字段
     */
    ComplexField = 'ComplexField'
}

/**
 * 字段类型对象中的类型枚举
 */
export enum FormSchemaEntityFieldType$Type {
    /**
     * 字符串
     */
    StringType = 'StringType',
    /**
     * 备注
     */
    TextType = 'TextType',
    /**
     * 数字（整数、浮点数）
     */
    NumericType = 'NumericType',
    /**
     * 布尔
     */
    BooleanType = 'BooleanType',
    /**
     * 日期
     */
    DateType = 'DateType',
    /**
     * 日期时间
     */
    DateTimeType = 'DateTimeType',
    /**
     * 枚举
     */
    EnumType = 'EnumType',
    /**
     * 实体类
     */
    EntityType = 'EntityType',
    /**
     * 分级码
     */
    HierarchyType = 'HierarchyType',
    /**
     * 对象
     */
    ObjectType = 'ObjectType',
    /**
     * 数字（大数据）
     */
    BigNumericType = 'BigNumericType'
}


/**
 * 字段类型中的名称
 */
export enum FormSchemaEntityFieldTypeName {
    /**
     * 简单类型字段
     */
    String = 'String',
    /**
     * 日期时间
     */
    DateTime = 'DateTime',
    /**
     * 日期
     */
    Date = 'Date',
    /**
     * 枚举
     */
    Enum = 'Enum',
    /**
     * 布尔
     */
    Boolean = 'Boolean',
    /**
     * 数字
     */
    Number = 'Number',
    /**
     * 备注
     */
    Text = 'Text',
    /**
     * 大数字
     */
    BigNumber = 'BigNumber'
}
